var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBuilderActivities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "extracurricular-activities",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55650",
    "data-name": "Path 55650",
    d: "M15.028,119.953l-5.855,5.861h5.855Z",
    transform: "translate(-8.349 -109.176)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55651",
    "data-name": "Path 55651",
    d: "M19.338,110.77H9.374V118.8a1.348,1.348,0,0,1-1.348,1.348H0v15.366a1.348,1.348,0,0,0,1.348,1.348H19.338a1.348,1.348,0,0,0,1.348-1.348v-23.4A1.348,1.348,0,0,0,19.338,110.77Z",
    transform: "translate(0 -100.818)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55652",
    "data-name": "Path 55652",
    d: "M457.169,51.54a10.22,10.22,0,0,0,.1-13.811C453.85,41.956,454.04,46.906,457.169,51.54Z",
    transform: "translate(-413.906 -34.339)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55653",
    "data-name": "Path 55653",
    d: "M336.882,19a10.221,10.221,0,0,0,10.722-.077,1.326,1.326,0,0,1-.084-.109c-4.484-6.6-3.394-12.69.211-17.176a10.221,10.221,0,0,0-11.062-.025C341.251,8.232,340.339,14.4,336.882,19Z",
    transform: "translate(-306.421)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55654",
    "data-name": "Path 55654",
    d: "M287.01,51.159c3.156-4.269,2.754-9.21-.3-13.758a10.222,10.222,0,0,0,.163,13.935C286.935,51.255,286.988,51.19,287.01,51.159Z",
    transform: "translate(-258.524 -34.041)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55655",
    "data-name": "Path 55655",
    d: "M288.831,273.015l-11.159-3.036a1.348,1.348,0,0,0-1.7,1.3v8.5a4.137,4.137,0,1,0,2.7,3.878v-10.61l8.463,2.3v8.32a4.137,4.137,0,1,0,2.7,3.878V274.315A1.348,1.348,0,0,0,288.831,273.015Z",
    transform: "translate(-246.099 -245.679)",
    fill: "#387f75"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderActivities);
export default __webpack_public_path__ + "static/media/profile-builder-activities.dcf2045f0ac73cfa86592cd87544e712.svg";
export { ForwardRef as ReactComponent };